<template>
  <div class="swiper-container">
    <swiper ref="slideSwiper" :options="swiperOption">
      <swiper-slide v-for="(file, index) in slideFiles" v-bind:key="index"
                    :class="index === 0 ? 'lession-first-slide':''"
                    style="">
        <div class="slide-list position-relative">
          <div class="swiper-zoom-container">
            <img :src="file">
            <div
                class="waterMarkContainer position-absolute d-flex align-items-center justify-content-center flex-column">
              <div class="waterMarkInner">
                <div class="t-headline7 t-color-whiteSelected t-center mgb-16">
                  {{ personalInfo ? personalInfo.userId : '' }}
                </div>
                <div class="t-headline7 t-color-blackHover t-center">{{
                    personalInfo ? personalInfo.userId : ''
                  }}
                </div>
              </div>
            </div>
          </div>

        </div>
      </swiper-slide>
    </swiper>
    <div class="swiper-button-next swiper-button-white"></div>
    <div class="swiper-button-prev swiper-button-white"></div>
  </div>
</template>

<script>
import {csStudyType} from "@/mixins/csStudyType";
import {slideTypeMixins} from "@/mixins/slideType";
import {MDCRipple} from "@material/ripple";
import microLearnApi from "@/api/microLearnApi";
import 'swiper/dist/css/swiper.css'
import {swiper, swiperSlide} from 'vue-awesome-swiper'

export default {
  name: "SlideType",

  props: ['lessonDataObj'],

  mixins: [slideTypeMixins, csStudyType],

  components: {
    swiper,
    swiperSlide
  },

  watch: {
    'enablNext'(val) {
      this.slideSwiper.allowSlideNext = val
    },

    'isAllPages'() {
      this.updateSwiper()
    },

    'isScroll'() {
      let direction = this.isScroll ? 'vertical' : 'horizontal'
      this.slideSwiper.changeDirection(direction)
    },

    'isTimeline'() {
      this.updateSwiper()
    },

    'isExpand'() {
      if (this.isExpend) {
        this.swiperOption.slidesPerView = 2
      } else {
        this.swiperOption.slidesPerView = 'auto'
      }
      this.updateSwiper()
    },

    'setSlideNumber'() {
      this.slideSwiper.slideTo(this.setSlideNumber - 1)
    }

  },

  data() {
    return {
      slideFiles: this.lessonDataObj.slide.files,
      time: 0,
      currentSlide: 0,
      nextLesson: '',
      isAllPages: false,
      isScroll: false,
      isTimeline: false,
      endedLesson: false,
      personalInfo: null,
      progressBar: 0,
      zoomValue: 100,
      isIndex: false,
      questionChat: '',
      content: 'Ace Editor',
      learningLanguage: '',
      socketUrl: "",
      authorization: "",
      sessionId: "",
      socket: null,
      ansi: undefined,
      socketResult: '',
      swiperOption: {
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 22,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        zoom: {
          maxRatio: 1.3,
          minRation: 1,
          toggle: false
        },
      },
      swiperOptionThumbs: {
        slidesPerView: 5,
        spaceBetween: 15,
        centeredSlides: true,
        //touchRatio: 0.2,
        slideToClickedSlide: true,
        allowTouchMove: false,
        direction: 'vertical',
      },
      startIndex: 0,
      startTime: 0,
      // time: 5,
      enablNext: false,
      teacherName: '',
      learnPurposes: '',
    }
  },

  mounted() {
    this.fetchSwiper();
  },

  methods: {
    fetchSwiper() {
      this.slideSwiper = this.$refs.slideSwiper.swiper
      this.startIndex = this.recent ? this.recent - 1 : 0
      if (this.startIndex > 0 && this.startIndex < this.slideFiles.length - 1) {
        this.$confirm({
          title: this.$t('173'), // '학습 중인 강의입니다.',
          content: this.$t('174') + '<br>' + this.$t('175'), //'이전에 학습했던 이력이 있습니다.<br>이어서 학습하시겠습니까?',
          accept: this.$t('177'), //'이어서 보기',
          cancel: this.$t('176'), //'처음부터 보기',
        }).then(() => {
          this.slideSwiper.slideTo(this.startIndex)
        }).catch(() => {
          this.slideSwiper.slideTo(0)
        })
      } else {
        this.slideSwiper.slideTo(0)
      }

      if (this.time > 0 && this.startIndex + 1 > this.last) {
        this.runTimer(this.startIndex)
      } else {
        this.enablNext = true
      }

      this.slideSwiper.allowSlideNext = this.enablNext

      this.slideSwiper.on('touchStart', () => {
      })

      this.slideSwiper.on('touchEnd', () => {
        this.$emit('zoomOut')
      })


      this.slideSwiper.on('imagesReady', () => {
        this.$hideLoading()
      })

      this.$nextTick(() => {
        const swiperThumbs = this.$refs.swiperThumbs.swiper
        this.slideSwiper.controller.control = swiperThumbs
        swiperThumbs.controller.control = this.slideSwiper
      })
    },

    closeImageNav() {
      this.isIndex = false
      document.getElementById("gallery-thumbs-container").style.marginRight = "-300px";
      document.querySelector('.slide-slider').classList.remove("indexed")
    },

    // zoom out image
    zoomOut() {
      this.zoomValue = parseInt(this.zoomValue) - 100 > 100 ? 100 : 100
      if (this.zoomValue === 100) {
        this.zoomValue = 100
        this.$refs.imageSlide.zoomOutHandler()
      }
    },

    // End lesson
    updateEndedLesson(value) {
      this.endedLesson = value
      if (value === true) {
        let myLession = this.nextLesson;
        let myRoute = this.$route;
        let myRouter = this.$router;
        setTimeout(function () {
          let learnId = myRoute.params.learnId;
          let status = myRoute.query.status;
          if (myLession && myLession.contentsType && myLession.contentsType.value == 'VIDEO') {
            myRouter.push(`/micro-study/${learnId}/${myLession.id}/lessonContents/${myLession.progressionId}?status=` + status)
          } else if (myLession && myLession.contentsType && myLession.contentsType.value == 'EXAM_PAPER') {
            myRouter.push(`/micro-study/${learnId}/lessonExam/${myLession.examineeId}/intro?status=` + status)
          } else if (myLession && myLession.contentsType && myLession.contentsType.value == 'PDF') {
            myRouter.push(`/micro-study/${learnId}/${myLession.id}/lessonContents/${myLession.progressionId}?status=` + status)
          } else if (myLession && myLession.contentsType && myLession.contentsType.value == 'SLIDE') {
            myRouter.push(`/micro-study/${learnId}/${myLession.id}/lessonContents/${myLession.progressionId}?status=` + status)
          } else {
						//Todo 확인 필요
            myRouter.push(`/learn/${learnId}?status=` + status)
          }
        }, 5000);
      }
    },

    // API 파라미터 설정(set parameter)
    setParams() {
      let params = {
        total: this.slideFiles.length,
        current: this.currentSlide,
        learnId: this.$route.params.learnId,
        progressionId: this.$route.params.progressionId
      }
      return params
    },

    // 학습 목록 API 호출(get lesson list)
    fetchLectureList() {
      let responseData = null
      let params = this.setParams()

      //차시 정보
      microLearnApi.learnViewCourses(params).then((response) => {
        // 과정의 차시 정보만 병합
        // Merging only lesson data from the course
        _.each(response.data.data, (course) => {
          this.lessonsList = this.lessonsList.concat(course.lessons)
        })

        // 다음 차시명 설정(set next lesson)
        let currentLessonIndex = _.findIndex(this.lessonsList, (lesson) => {
          return lesson.progressionId === this.currentProgressionId
        })
        let nextLessonIndex = this.lessonsList.length > 1 && this.lessonsList.length > currentLessonIndex ? currentLessonIndex += 1 : -1
        if (nextLessonIndex) {
          this.nextLesson = this.lessonsList[nextLessonIndex]
          if (nextLessonIndex === -1) {
            this.nextLessonName = this.$t('1999')
          } else {
            if (typeof (this.lessonsList[nextLessonIndex]) != "undefined") {
              this.nextLessonName = this.lessonsList[nextLessonIndex].name
            } else {
              this.nextLessonName = this.$t('1999')
            }

          }
        }
      }).catch((err) => {
      })
    },

    async onToggleQuiz() {
      if (this.isTimelineResource) {
        this.isTimelineResource = false
        await this.onToggleResource()
      }

      return new Promise(resolve => {
        const elementBody = document.querySelector('body')
        this.isTimelineQuiz = false

        if (!elementBody.classList.contains('quiz-overlay')) {
          this.mainTransitionName = 'slide-up'
          elementBody.classList.add('quiz-overlay')
          this.isQuizVisible = true
          this.isTimeline = true
          resolve()

        } else {
          this.mainTransitionName = 'slide-up'
          this.isQuizVisible = false

          setTimeout(() => {
            elementBody.classList.remove('quiz-overlay')
            this.isTimeline = false
            resolve()
          }, 500)
        }
      })
    },

    async onToggleResource() {
      if (this.isQuizVisible) {
        this.isTimelineQuiz = false
        this.isQuizVisible = false
        await this.onToggleQuiz()
      }

      return new Promise(resolve => {
        const elementBody = document.querySelector('body')

        if (!elementBody.classList.contains('quiz-overlay')) {
          this.mainTransitionName = 'slide-up'
          if (this.isPortrait) {

          }
          elementBody.classList.add('quiz-overlay')
          this.isResourceVisible = true
          resolve()

        } else {
          this.mainTransitionName = 'slide-up'

          this.isResourceVisible = false
          setTimeout(() => {
            elementBody.classList.remove('quiz-overlay');
            resolve()
          }, 500);
        }
      })
    },
  }
}
</script>

<style scoped>

span.video-watermark {
  position: absolute;
  font-size: 12px;
  transform: rotate(-45deg);
  opacity: 0.25;
  cursor: none;
  z-index: 99;
}

span.video-watermark.light {
  color: var(--DocumentWhite);
  top: 50%;
  left: 40%;
  transform: translate(-40%, -50%) rotate(-45deg);
}

html[dir="rtl"] span.video-watermark.light {
  right: 40%;
}

span.video-watermark.dark {
  color: var(--HeadlineBlack);
  top: 50%;
  left: 51%;
  transform: translate(-51%, -50%) rotate(-45deg);
}

html[dir="rtl"] span.video-watermark.dark {
  right: 51%;
}

@media (min-width: 480px) {
  span.video-watermark.light {
    left: 45%;
    transform: translateX(-45%) rotate(-45deg);
  }

  html[dir="rtl"] span.video-watermark.light {
    right: 45%;
    transform: translateX(-45%) rotate(-45deg);
  }
}

#playlistContainer.show {
  z-index: 999;
}

.bg-dark1 {
  background-color: #1b232b;
}

.bg-divider {
  background: rgba(206, 218, 220, 0.2) !important;
}

.t-color-gray9 {
  color: var(--ContentVariationInactive) !important;
}

.content-box {
  min-height: calc(100vh - 209px);
}

.font-13 {
  font-size: 13px !important;
}


.paging.active {
  opacity: 1;
}

.swiper-wrapper {
  align-items: center !important;
}

.swiper-slide {
  width: 88%;
}

.portrait-footer {
  position: fixed;
  width: 100%;
  bottom: 0;
}

.likeVideo.active {
  color: var(--ContentRed) !important;
}

.addBookmark.active {
  color: var(--ContentBlue) !important;
}

@media (orientation: landscape) {
  .portrait-view {
    display: none;
  }

  body:not(.all-pages) #videoContainer > #verticalList {
    width: 145px;
    position: absolute;
    right: 0;
    /* display: block !important; */
    padding-right: 50px;
    padding-left: 15px;
  }

  html[dir="rtl"] body:not(.all-pages) #videoContainer > #verticalList {
    left: 0;
    padding-left: 50px;
    padding-right: 15px;
  }

  #videoContainer.full-image #wrap-slide-contents .slide-list img {
    object-fit: cover !important;
  }

  #videoContainer > #verticalList > ul {
    overflow-y: scroll;
    height: 75vh;
  }

  #videoContainer .w-full.custom-width {
    width: calc(100% - 210px) !important;
  }
}

.home-progressbar {
  position: absolute;
  height: 4px;
  background: var(--Saleline);
}

.disAbledPlusAndMinus {
  opacity: 0.5
}

.intro-button.position-absolute {
  right: 10px;
  bottom: 10%;
  z-index: 9999;
}

html[dir="rtl"] .intro-button.position-absolute {
  left: 10px;
}
</style>
